import React from 'react';
import { useNavigate } from 'react-router-dom';
import BoardList from '../components/board/BoardList';
import useAuth from '../hooks/useAuth';
import ResponsiveHeader from "../components/common/ResponsiveHeader";

const BoardListPage = () => {
    const user = useAuth(); // 페이지 접근 제어
    const navigate = useNavigate();

    if (!user) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <ResponsiveHeader title="Work Manager" />
            <main>
                <BoardList onSelectBoard={(board) => navigate(`/board/${board.id}`)} />
            </main>
        </div>
    );
};

export default BoardListPage;
